import React from 'react';

import { CTASection } from './components/CTASection';
import { FilterablePetitionsSection } from './components/FilterablePetitionsSection';
import { PetitionUpdates } from './components/PetitionUpdates';
import { RelatedTopicPages } from './components/RelatedTopicPages';
import { SupporterVoices } from './components/SupporterVoices';
import { TopicBreadcrumbs } from './components/TopicBreadcrumbs';
import { TopicContentSection } from './components/TopicContentSection';
import { VictoriousPetitionsSection } from './components/VictoriousPetitionsSection';

export const PageBody: React.FC = () => {
	return (
		<div className="flex flex-col gap-16 py-16">
			<FilterablePetitionsSection />
			<TopicContentSection />
			<RelatedTopicPages />
			<PetitionUpdates />
			<VictoriousPetitionsSection />
			<SupporterVoices />
			<CTASection />
			<TopicBreadcrumbs />
		</div>
	);
};
